export const removeProjectNameFromId = (id: string | undefined) => {
  return id?.split('-').pop();
};
